import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'EFICCI';
render(<App data-id="element-242" />, document.getElementById('root'));